import Login from './login';

export default {
  namespaced: true,
  modules: {
    Login,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/access_provider/users/index.js